export default {"src":"/_next/static/media/arrow-right.e4819838.svg","height":11,"width":6,"blurWidth":0,"blurHeight":0};